import React from 'react';
import Grid from '@mui/material/Grid';
import HTMLReactParser from 'html-react-parser';
import './home.css';
import { useGlobal } from '../../utils/GlobalContext';
import { Box } from '@mui/material';

export default function JumbotronComponent() {
  const { state } = useGlobal();

  return (
    <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
              <h1 className='textAccentColor1 topSpacer36px'>
                {state.Conference.Name}
              </h1>
              <p>
                {state.Conference.Address1}<br/>
                {state.Conference.City}, {state.Conference.State}
              </p>
              <p>
                {HTMLReactParser(state.Conference.Description.toString() ?? "")}
              </p>
          </Grid>
          <Grid className='jumbotron' item xs={12} md={6} container justifyContent='flex-end'>
            <img alt='Site Logo' src={state.Conference.Image} />
          </Grid>
        </Grid>
      </Box>
  );
}